<template>
    <v-text-field
        flat
        class="text-field"
        v-bind="$props"
        v-on:input="updateValue"
        :clearable="clearable"
        :disabled="disabled"
        :hide-details="hideDetails ? true : false"
        :solo="solo"
        :value="value"
        @keydown.enter="$emit('on-enter')"
    ></v-text-field>
</template>

<script>
export default {
    props: ["placeholder", "required", "rules", "value", "type", "hideDetails", "solo", "disabled", "clearable"],
    data() {
        return {
            intervalValue: null,
        };
    },
    methods: {
        updateValue: function (value) {
            this.$emit('input', value)
        }
    },
};
</script>

<style lang="sass">
    .text-field
        &.v-text-field--solo
            border-radius: 0
            position: relative

        .v-input__control > .v-input__slot
            margin-bottom: 0

        .v-text-field__details
            position: relative
            top: 2px

        input:-webkit-autofill
            -webkit-box-shadow: 0 0 0 1000px white inset
</style>
